// Auto-generated first-level keys from en.json
// This file is generated by scripts/get-first-level-keys.js
// NOTE: Despite being auto-generated, this file should be committed to git
// to prevent TypeScript compilation errors before running any scripts
export const FIRST_LEVEL_KEYS = new Set([
  'layout',
  'pages',
  'portal',
  'shared',
  'languages',
  'services',
  'error-messages',
  'tenantOverlay',
  'auth',
  'services-auth',
  'services-loader',
  'services-app',
  'portal-activities',
  'portal-clients',
  'portal-reports',
  'responseBean',
  'validation-service',
  'reminder',
  'TRANSACTION_NUMBER_PENDING_TRY_LATER',
  'printout'
]);

export function isFirstLevelKey(key: string): boolean {
  return FIRST_LEVEL_KEYS.has(key);
}
